class Theme {
    public apply(value: string | null): void {
        if (value === null) {
            document.documentElement.removeAttribute('data-theme');
            return;
        }

        document.documentElement.setAttribute('data-theme', value);
    }
}

declare global {
    interface Window {
        Theme: Theme;
    }
}

globalThis.Theme = new Theme();

export { };
